import { PropsWithChildren } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';

import { SiteConfigDto } from '@pimm/services/lib/sms-tenants';
import { useGetEquipmentProfile } from '../hooks/get-equipment-profile.hook';
import { useGetKitchenLayout } from '@app/features/kitchen-positioning/hooks/get-kitchen-layout.hook';

type StoreSettingsReturn = {
  isEquipmentEditable?: boolean;
  isStoreHoursEditable?: boolean;
  site: SiteConfigDto;
  queryEquipmentProfiles: ReturnType<typeof useGetEquipmentProfile>;
  queryKitchenLayout: ReturnType<typeof useGetKitchenLayout>;
  onConfigChange: (_StoreSettings: SiteConfigDto) => void;
  onSupportPress?: () => void;
};

type StoreSettingsProviderProps = PropsWithChildren & StoreSettingsReturn & {};

const StoreSettingsContext = createContext<StoreSettingsReturn>(undefined!);

export const StoreSettingsProvider = ({ children, ..._props }: StoreSettingsProviderProps) => {
  return <StoreSettingsContext.Provider value={{ ..._props }}>{children}</StoreSettingsContext.Provider>;
};

export const useStoreSettings = <T,>(selector: (context: StoreSettingsReturn) => T): T =>
  useContextSelector(StoreSettingsContext, selector);
